// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import backlogPriorityEntity from './entities/backlog-priority.json';
import backlogPriorityMenu from '../pages/backlog-priority/menu.json';
import backlogPriorityFullForm from '../pages/backlog-priority/forms/full.json';
import backlogPriorityContextForm from '../pages/backlog-priority/forms/context.json';
import backlogPriorityMiniForm from '../pages/backlog-priority/forms/mini.json';
import backlogPriorityLookupForm from '../pages/backlog-priority/forms/lookup.json';
import backlogPriorityTableView from '../pages/backlog-priority/views/table.json';
import backlogPriorityCardsView from '../pages/backlog-priority/views/cards.json';
import backlogPriorityDashboardView from '../pages/backlog-priority/views/dashboard.json';

/** Тип запису «Пріоритет у беклозі» зі сторінками пакета: меню, форми та подання з pages/backlog-priority/. */
export const backlogPriorityDefinition: IRecordTypeDefinition = {
  ...backlogPriorityEntity,
  views: assembleViewSet({
      table: backlogPriorityTableView,
      cards: backlogPriorityCardsView,
      dashboard: backlogPriorityDashboardView,
  }),
  form: backlogPriorityFullForm,
  forms: { full: backlogPriorityFullForm, context: backlogPriorityContextForm, mini: backlogPriorityMiniForm, lookup: backlogPriorityLookupForm },
  menu: backlogPriorityMenu,
} as IRecordTypeDefinition;
